<template>
  <div class="login-wrapper">
    <div class="login-main clearfix">
      <div class="login-input">
        <div class="login-logo">
          <img src="../../assets/images/wago-logo.png" alt="logo">
        </div>
        <div class="login-title">
          产品追溯平台
        </div>
        <div class="login-subtitle">
          Product Traceable Platform
        </div>
        <div class="login-userinfo">
          <el-form :rules="rules" :model="userInfo" size="small" ref="loginForm" @keyup.enter.native="login('loginForm')" :status-icon="true" :show-message="false">
            <el-form-item prop="username">
              <el-input v-model="userInfo.username" :autofocus="true" :placeholder="$t('login.placeholder.userName')"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="userInfo.password" :placeholder="$t('login.placeholder.password')"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="login-btn" type="primary" :loading="logining" @click="login('loginForm')" size="small">{{$t("login.title")}}</el-button>
            </el-form-item>
            <el-checkbox v-model="rememberMeChecked" class="rem-me" size="small">{{$t("login.rememberMe")}}</el-checkbox>
          </el-form>
        </div>
        <div class="footer-link">
          <a href="http://www.wago.com.cn/">WAGO中国></a>
          <a href="mailto:wagocm@wago.com">联系我们></a>
        </div>
      </div>
      <div class="login-img">
        <img src="../../assets/images/wagoPic.jpg" alt="logo">
        <div class="login-link">
          <div>电气连接与自动化解决方案</div>
          <div>的行业领导者</div>
          <a href="http://www.wago.com.cn/wago/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC/index.jsp" class="detail">详情></a>
        </div>
      </div>

    </div>
    <div class="copy-right">
      Copyright @ {{year}} WAGO Corporation. All rights reserved.
    </div>
  </div>
</template>

<script>
//import router from "@/router/index";
import qs from "qs";
import * as types from "@/store/types";
import { mapGetters } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      userInfo: {
        username: "",
        password: "",
        grant_type: "password"
      },
      year: new Date().getFullYear(),
      rememberMeChecked: "",
      logining: false,
      rules: {
        username: [
          {
            required: true,
            message: this.$t("login.usernameRuleMessage"),
            trigger: "change"
          }
        ],
        password: [
          {
            required: true,
            message: this.$t("login.passwordRuleMessage"),
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    login(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.logining = true;
          this.$axios
            .post("token", qs.stringify(this.userInfo))
            .then(response => {
              this.$store.commit(types.LOGIN, response.data);
              let redirect = decodeURI(this.$route.query.redirect || "/");
              this.$router.push({ path: redirect });
            })
            .catch(error => {
              let msg = this.$t("login.loginFailure");
              const resp = error.response;
              if(!resp){
                msg = "服务器错误，请联系管理员"
              }
              
              if (resp && resp.data && resp.data.error) {
                msg = `登录失败：${resp.data.error_description}`;
              }
              this.$message({
                message: msg,
                type: "error",
                duration: 3000
              });
              this.logining = false;
            });
        } else {
          return false;
        }
      });
    }
  },
  computed: {
    ...mapGetters(["menus"])
  },
  created() {}
};
</script>

<style>
.login-wrapper {
  height: 100%;
  background-color: #e3e3e3;
  padding-top: 200px;
}

.login-main,
.copy-right {
  width: 598px;
  margin: auto;
}

.login-main {
  background-color: #fff;
  box-shadow: 2px 2px 3px #a0a0a0;
}

.login-input {
  width: 210px;
  height: 100%;
  padding: 8px 8px 8px 10px;
}

.login-logo img {
  height: 45px;
  display: inline-block;
  padding-left: 2px;
}

.login-title,
.login-subtitle {
  color: #7ab51d;
}

.login-title {
  font-size: 32px;
  padding-top: 10px;
}

.login-subtitle {
  font-size: 13px;
  font-weight: 700;
  margin-top: 8px;
  margin-bottom: 5px;
}

.login-userinfo > .el-form > .el-form-item {
  margin: 0;
}
.login-userinfo > .el-form > .el-form-item > .el-form-item__content {
  line-height: 30px;
}

.login-userinfo > .el-form .el-input__inner {
  margin: 0;
  border-radius: 0;
  height: 28px;
  font-size: 14px;
  padding: 5px 10px;
}

.login-userinfo > .el-form .el-input__inner:focus {
  border-color: #66afe9;
}

:-ms-input-placeholder.el-input__inner {
  color: #b4bccc;
}

.login-userinfo .login-btn {
  display: block;
  width: 100%;
  height: 32px;
  border-radius: 0;
  margin-top: 3px;
  border: none;
}

.login-userinfo .login-btn span {
  font-size: 16px;
  font-weight: 700;
}

.rem-me {
  padding-bottom: 10px;
}

.rem-me > span {
  padding-top: 2px;
  font-size: 12px;
}

.rem-me .el-checkbox__inner {
  width: 13px;
  height: 13px;
}

.login-img {
  padding-top: 8px;
  padding-right: 8px;
  position: relative;
}

.login-img img {
  width: 380px;
  height: 231px;
}

.login-img .login-link {
  position: absolute;
  top: 20px;
  right: 20px;
  text-align: right;
  line-height: 1.5;
  color: #656565;
}

.login-img .login-link div {
  font-size: 16px;
}

.login-img .login-link a.detail {
  display: inline-block;
  padding: 3px 8px 5px 8px;
  background: #58ab27;
  color: #fff;
  margin-top: 2px;
  font-size: 12px;
}

.login-input,
.login-img {
  float: left;
}

.footer-link a {
  color: #8bb63b;
  margin-right: 10px;
  text-decoration: underline;
  font-size: 13px;
}

.copy-right {
  color: #656565;
  font-size: 12px;
  text-align: center;
  padding-top: 5px;
  font-family: "Microsoft YaHei", sans-serif;
}

@media screen and (max-width: 768px) and (orientation: portrait) {
  .login-img {
    display: none;
  }

  .login-main,
  .copy-right {
    width: 97%;
  }

  .login-wrapper {
    padding-top: 150px;
  }

  .login-input {
    width: 100%;
  }
}

@media screen and (max-width: 768px) and (orientation: landscape) {
  .login-wrapper {
    padding: 60px 68px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/login/Login.vue